import { useState } from "react";
import { Dialog } from "@mui/material";

export default function MessageItem({ message }) {
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  return (
    <div
      className={`d-flex flex-column mb-5 ${
        message.isMine ? "align-items-start" : "align-items-end"
      }`}
    >
      {message.isMine ? (
        <div className="d-flex align-items-center">
          <div className="symbol symbol-circle symbol-40 mr-3">
            <img src={message.user_avatar} alt="user-avatar" />
          </div>
          <div className="d-flex align-items-center gap-1 font-weight-bold font-size-h6">
            {message.user_name}
            <span className="text-muted font-size-sm">{message.sent_time}</span>
          </div>
        </div>
      ) : (
        <div className="d-flex align-items-center">
          <div className="d-flex align-items-center gap-1 font-weight-bold font-size-h6 pr-5">
            <span className="text-muted font-size-sm">{message.sent_time}</span>
            {message.user_name}
          </div>
          <div className="symbol symbol-circle symbol-40 mr-3">
            <img src={message.user_avatar} alt="user-avatar" />
          </div>
        </div>
      )}
      <div
        className={`d-flex flex-column mt-2 rounded p-5 ${
          message.isMine ? "bg-light-success" : "bg-light-primary"
        } font-weight-bold font-size-lg text-left max-w-400px`}
      >
        {message?.message
          ?.replace(/(\r\n|\n|\r)/gm, "][s")
          .split("][s")
          .map((word, index) => (
            <span key={index}>
              {word}
              <br />
            </span>
          ))}
        {message.attachment && (
          <>
            <img
              width="100px"
              height="100px"
              className="attach-file cursor-pointer"
              src={message.attachment}
              alt={message.message}
              style={{ borderRadius: "5px", objectFit: "cover" }}
              onClick={() => setOpen(true)}
            />
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              sx={{
                ".MuiPaper-root": { backgroundColor: "transparent" },
              }}
            >
              <img
                className="attach-file"
                src={message.attachment}
                alt={message.message}
                onClick={() => setOpen(false)}
              />
            </Dialog>
          </>
        )}
      </div>
    </div>
  );
}

export function MessageItemLoading({ isFile, index }) {
  return (
    <div
      className={`d-flex flex-column mb-5 ${
        index % 2 === 0 ? "align-items-start" : "align-items-end"
      }`}
    >
      <div className="d-flex align-items-center">
        <div
          className={`symbol symbol-circle symbol-40 loading-icon ${
            index % 2 === 0 ? "bg-light-success" : "bg-light-primary"
          } w-30px h-30px`}
        />
        <div className="d-flex align-items-center gap-1 font-weight-bold font-size-h6 loading-row" />
      </div>
      <div
        className={`d-flex flex-column mt-2 rounded p-5 ${
          index % 2 === 0 ? "bg-light-success" : "bg-light-primary"
        } full-width font-weight-bold font-size-lg text-left max-w-400px loading-row`}
      ></div>
      {isFile && (
        <span
          className={`loading-row ${
            index % 2 === 0 ? "bg-light-success" : "bg-light-primary"
          }`}
          style={{
            width: "200px",
            height: "125px",
            marginTop: "0.3rem",
          }}
        />
      )}
    </div>
  );
}
